import * as yup from 'yup';

export const RoleFormSchema = yup.object().shape({
  name: yup.string().required(),
});
